module.exports = __webpack_public_path__ + "static/img/f9_icon_coins@2x.d6eb43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/f9_icon_coins@2x.png
// module id = FSLV
// module chunks = 0